import React, {useContext, useEffect} from 'react';
import {NavBar} from 'Components/Nav/NavBar';
import s from './styles/About.module.scss';
import graduation from './static/graduation.jpeg'
import Footer from './Footer';
import {FaHandshake, FaRegEye, FaRibbon, FaSearch, FaUserShield} from "react-icons/all";
import {useScroll} from "../../Utils/helpers";
import {logElementInteraction} from "../../Api/Utils/referral";
import {getDeviceId, isLoggedIn, SessionContext} from "../../Utils/sessions";

const About = () => {
  const {session} = useContext(SessionContext);
  const isScrolled = useScroll(5)

  useEffect(() => {
    logElementInteraction( {
      elementId: `about::page::${isLoggedIn(session) ? 'authenticated' : 'public'}`,
      type: 'VIEW',
      deviceId: getDeviceId(),
      data: localStorage.getItem('userInfo'),
      source: 'WEB'
    }).then(() => {}).catch(() => {});
  }, [session])

  return <>
    <div className={s.about}>
      <div className={`${s.navBarContainer} ${isScrolled ? s.navBarScrolled : ''}`}>
        <NavBar className={s.navBar}/>
      </div>
      <div className={`${s.headerSection}`}>
        <div className={s.headerContent}>
          <h1><strong>About Us</strong></h1>
          <h3 className={s.subheader}>{`College is a huge decision. You shouldn't have to make it alone.`}</h3>
        </div>
      </div>
      <div className={s.contentSection}>
        <img src={graduation ?? ''} alt={'graduation'}/>
        <h2>{`Our Mission`}</h2>
        <p>
        The path to higher education is filled with noise—rankings, brochures, and statistics. While useful, they
          often miss the human element that defines the college experience. We saw students making one of the biggest
          decisions of their lives based on incomplete information, leading to uncertainty and costly transfers.
        </p>
        <p>
          Our mission is to democratize access to authentic, firsthand college advice. We believe that by fostering
          genuine conversations between current and prospective students, we can empower the next generation to make
          more confident, informed decisions and find a college where they will truly thrive.
        </p>
      </div>
      <div className={s.contentSection}>
        <h2>{`A Platform for Both Sides of the Journey`}</h2>
        <div className={s.platformShowcaseContainer}>
          <div className={s.platformShowcaseItem}>
            <div className={s.itemIconWrapper}>
              <FaSearch/>
            </div>
            <h4>High School Students</h4>
            <p>
              {`Get answers to the questions you can't ask a tour guide. Connect with college mentors who share your
              interests and can provide an unfiltered look into campus life, academics, and culture.`}
            </p>
          </div>
          <div className={s.platformShowcaseItem}>
            <div className={s.itemIconWrapper}>
              <FaRibbon/>
            </div>
            <h4>College Mentors</h4>
            <p>
              {`Share your story, make an impact, and get paid for your time. Help guide the next class of students
              while building your communication and leadership skills in a flexible, rewarding way.`}
            </p>
          </div>
        </div>
      </div>
      <div className={s.contentSection}>
        <h2>Our Guiding Principles</h2>
        <h5 className='text-muted'>Everything we do is guided by a few simple but powerful beliefs.</h5>
        <div className={s.principleContainer}>
          <div className={s.principleItem}>
            <div className={s.itemIconWrapper}>
              <FaUserShield/>
            </div>
            <h4>Safety</h4>
            <p>
              Your privacy and security are paramount. We are committed to creating a safe and respectful environment
              for all users through secure technology and clear community guidelines.
            </p>
          </div>
          <div className={s.principleItem}>
            <div className={s.itemIconWrapper}>
              <FaRegEye/>
            </div>
            <h4>Transparency</h4>
            <p>
              We believe in honest, unfiltered conversations. We provide clear information about our platform and
              empower mentors to share their genuine experiences without a marketing spin.
            </p>
          </div>
          <div className={s.principleItem}>
            <div className={s.itemIconWrapper}>
              <FaHandshake/>
            </div>
            <h4>Trust</h4>
            <p>
              Trust is the foundation of meaningful mentorship. We work to earn it in every interaction by fostering a
              reliable community where students can feel confident in the guidance they receive.
            </p>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </>
};

export default (About);
